module.exports = __webpack_public_path__ + "static/media/slt_card_expert.c887a89f.png";